import { render, staticRenderFns } from "./ProductIncipitInfoBook.vue?vue&type=template&id=4a4b5827"
import script from "./ProductIncipitInfoBook.vue?vue&type=script&lang=ts"
export * from "./ProductIncipitInfoBook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports